{
  "page_title": "Asiakkaat",
  "table": {
    "name": "Nimi",
    "code": "Koodi",
    "country": "Maa",
    "type": "Tyyppi",
    "created": "Luotu",
    "features": "Ominaisuudet",
    "click_to_edit": "Klikkaa muokataksesi",
    "no_matches": "Ei hakua vastaavia asiakkaita"
  },
  "list": {
    "search_placeholder": "Hae nimellä tai koodilla",
    "type_filter_all": "Kaikki tyypit",
    "features": {
      "payments": "Maksut",
      "ebirdie": "eBirdie",
      "system36": "System 36",
      "addons": "Lisäpalvelut",
      "polls": "Kyselyt"
    },
    "feature_enabled": "{{feature}} käytössä",
    "feature_disabled": "{{feature}} ei käytössä",
    "legend": {
      "enabled": "Käytössä",
      "disabled": "Ei käytössä"
    }
  },
  "create": {
    "title": "Luo uusi asiakas",
    "subtitle": "Lisää uusi golfklubi tai organisaatio järjestelmään",
    "breadcrumb": "Uusi asiakas",
    "success": "Asiakas \"{{name}}\" luotu onnistuneesti!",
    "error": "Asiakkaan luominen epäonnistui: {{message}}",
    "submit_button": "Luo asiakas"
  },
  "edit": {
    "breadcrumb": "Muokkaa",
    "success": "Asiakas \"{{name}}\" päivitetty onnistuneesti!",
    "error": "Asiakkaan päivittäminen epäonnistui: {{message}}",
    "submit_button": "Päivitä asiakas",
    "error_loading": "Virhe ladattaessa asiakasta",
    "back_to_list": "Takaisin asiakaslistaan"
  },
  "delete": {
    "danger_zone": "Vaaravyöhyke",
    "danger_zone_description": "Kun poistat asiakkaan, se poistetaan pehmeästi ja kaikki hallinnoijien liitokset poistetaan. Tämä toiminto vaikuttaa kaikkiin tähän asiakkaaseen liittyviin käyttäjiin.",
    "button": "Poista asiakas",
    "confirm_header": "Poista asiakas \"{{name}}\"",
    "confirm_body": "Oletko varma että haluat poistaa asiakkaan \"{{name}}\"?\n\nTämä:\n• Poistaa asiakkaan pehmeästi (asettaa deletedAt-aikaleiman)\n• Poistaa kaikki hallinnoijien liitokset\n• Tekee asiakkaasta käyttäjille esteellisen\n\nTämä toiminto voidaan tarkistaa järjestelmälokeista, mutta se tulee tehdä huolellisesti.",
    "confirm_button": "Poista asiakas",
    "success": "Asiakas \"{{name}}\" on poistettu onnistuneesti.",
    "error": "Asiakkaan poistaminen epäonnistui: {{message}}"
  },
  "form": {
    "tabs": {
      "basic": "Perustiedot",
      "contact": "Yhteystiedot",
      "payment": "Asetukset",
      "managers": "Käyttäjät"
    },
    "cards": {
      "features": "Ominaisuudet",
      "payment": "Maksaminen"
    },
    "fields": {
      "name": {
        "label": "Asiakkaan nimi",
        "placeholder": "Syötä golfklubin nimi",
        "help": "Golfklubin tai organisaation virallinen rekisteröity nimi."
      },
      "code": {
        "label": "Asiakaskoodi",
        "placeholder": "klubin-koodi",
        "help": "Uniikki tunniste, jota käytetään URL-osoitteissa. Vain pienet kirjaimet, numerot ja yhdysmerkit.",
        "available": "Koodi \"{{code}}\" on saatavilla",
        "taken": "Koodi \"{{code}}\" on jo käytössä"
      },
      "display_name": {
        "label": "Näyttönimi",
        "placeholder": "Lyhyt näyttönimi (valinnainen)",
        "help": "Valinnainen lyhyempi nimi näyttötarkoituksiin."
      },
      "country": {
        "label": "Maa",
        "placeholder": "Valitse maa",
        "help": "Maa, jossa golfklubi sijaitsee."
      },
      "type": {
        "label": "Asiakkaan tyyppi",
        "club": "Seura",
        "society": "Yhteisö",
        "union": "Liitto",
        "help": "Asiakkaan tyyppi: Seura, Yhteisö tai Liitto. Ei muutettavissa luonnin jälkeen."
      },
      "paytrailMerchantId": {
        "label": "Paytrail-kauppiastunnus",
        "placeholder": "",
        "help": "Shop-in-Shop alikauppiaan tunnus maksujen jakamiseen."
      },
      "vatRate": {
        "label": "ALV-prosentti",
        "placeholder": "",
        "help": "Oletusarvoinen arvonlisäveroprosentti (esim. 13.5 %)."
      },
      "commissionRate": {
        "label": "Komission prosentti",
        "placeholder": "",
        "help": "XenGolf-palvelun provisio maksuista (esim. 2.5 %)."
      },
      "commissionFixed": {
        "label": "Kiinteä komissio (€)",
        "placeholder": "",
        "help": "Kiinteä komissio euroina, joka vähennetään seuralle tilitetyistä maksuista."
      },
      "batch_submission_time": {
        "label": "eBirdie-lähetysaika",
        "help": "Kellonaika, jolloin tulokset lähetetään automaattisesti eBirdieen."
      },
      "ebirdieEnabled": {
        "label": "eBirdie käytössä",
        "help": "Kun pois päältä, eBirdie-toiminnot piilotetaan kilpailunhallinnasta eikä tuloksia lähetetä eBirdieen."
      },
      "system36Enabled": {
        "label": "System 36 käytössä",
        "help": "Kun päällä, System 36 on valittavissa sarjan tulostyypiksi."
      },
      "addOnsEnabled": {
        "label": "Lisäpalvelut käytössä",
        "help": "Kun päällä, lisäpalveluiden hallinta näkyy Hallinta-valikossa."
      },
      "pollsEnabled": {
        "label": "Kyselyt käytössä",
        "help": "Kun päällä, kentän palautekyselyiden hallinta näkyy Hallinta-valikossa ja pelaajille voidaan näyttää kysely kierroksen jälkeen."
      },
      "latitude": {
        "label": "Leveysaste",
        "placeholder": "esim. 60.1699"
      },
      "longitude": {
        "label": "Pituusaste",
        "placeholder": "esim. 24.9384"
      },
      "ebirdie_club": {
        "label": "Hae tiedot eBirdiesta",
        "title": "Valitse eBirdie-klubi",
        "placeholder": "Valitse seura",
        "loading": "Ladataan klubeja...",
        "prefilling": "Haetaan tiedot...",
        "error": "Klubien haku epäonnistui",
        "help": "Valitse klubi esitäyttääksesi lomakkeen eBirdien tiedoilla.",
        "select_button": "Valitse",
        "skip_button": "Jatka ilman valintaa"
      }
    },
    "validation": {
      "name_required": "Asiakkaan nimi on pakollinen",
      "name_min_length": "Asiakkaan nimen on oltava vähintään 2 merkkiä",
      "code_required": "Asiakaskoodi on pakollinen",
      "code_pattern": "Asiakaskoodi saa sisältää vain pieniä kirjaimia, numeroita ja yhdysmerkkejä",
      "code_min_length": "Asiakaskoodin on oltava vähintään 3 merkkiä",
      "code_max_length": "Asiakaskoodi saa olla enintään 50 merkkiä",
      "email_invalid": "Virheellinen sähköpostiosoite",
      "vat_required_with_merchant": "ALV-prosentti on pakollinen kun kauppiastunnus on asetettu"
    },
    "unsaved_changes": "Sinulla on tallentamattomia muutoksia",
    "saving": "Tallennetaan...",
    "save": "Tallenna"
  },
  "managers": {
    "current": "Nykyiset käyttäjät",
    "no_managers": "Tälle asiakkaalle ei ole määritetty käyttäjiä",
    "no_managers_help": "Lisää käyttäjiä",
    "add_manager": "Lisää käyttäjä",
    "search_placeholder": "Hae käyttäjiä sähköpostilla tai nimellä...",
    "reload": "Päivitä saatavilla olevat käyttäjät",
    "loading": "Ladataan käyttäjiä...",
    "no_results": "Käyttäjiä ei löytynyt haulle \"{{searchTerm}}\"",
    "no_results_help": "Kokeile eri hakusanaa",
    "no_available": "Ei saatavilla olevia käyttäjiä",
    "no_available_help": "Kaikki käyttäjät on jo määritetty asiakkaille tai poistettu.",
    "showing_first_10": "Näytetään ensimmäiset 10 tulosta. Jatka kirjoittamista rajaukseen.",
    "remove_manager": "Poista käyttäjä"
  }
}
